

module.exports = __webpack_require__.stylable.create(
    "Cta1247838702",
    {"classes":{"root":"Cta1247838702__root","common":"Cta1247838702__common","buttonEmptyCornered":"Cta1247838702__buttonEmptyCornered","buttonEmptyRounded":"Cta1247838702__buttonEmptyRounded","buttonFullCornered":"Cta1247838702__buttonFullCornered","buttonFullRounded":"Cta1247838702__buttonFullRounded"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "Cta1247838702",
    null
);
